import React from 'react';

function TermsOfService() {
    return (
        <div className="page">
            <header className="page-header">
                <span className="page-eyebrow">Legal</span>
                <h1>Terms of Service</h1>
                <p className="page-subtitle">Effective date: May 11, 2026</p>
            </header>

            <section className="panel">
                <p>
                    These Terms of Service ("Terms") govern your use of RecipeCore.net ("RecipeCore", "we", "us", "our").
                    By using the service, you agree to these Terms.
                </p>
                <p>
                    Operator: Douwe Hummeling, Liemarstrasse 25, 48691 Vreden, Germany.
                    Contact: support@pollarity.app.
                </p>
            </section>

            <section className="panel">
                <h2>1. Service description</h2>
                <p>
                    RecipeCore allows users to create accounts, extract and save recipes, manage preferences,
                    and optionally purchase one-time ad removal.
                </p>
            </section>

            <section className="panel">
                <h2>2. Accounts and user responsibilities</h2>
                <ul>
                    <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                    <li>You must provide accurate registration information.</li>
                    <li>You are responsible for activity conducted through your account.</li>
                    <li>You must not abuse, disrupt, reverse engineer, or misuse the service.</li>
                </ul>
            </section>

            <section className="panel">
                <h2>3. Payments and refunds</h2>
                <ul>
                    <li>Ad removal is offered as a one-time purchase.</li>
                    <li>Refunds are not provided unless the paid functionality does not work.</li>
                    <li>Payment processing is handled by Stripe and subject to Stripe terms.</li>
                </ul>
            </section>

            <section className="panel">
                <h2>4. Referral and creator payout terms</h2>
                <ul>
                    <li>Referral creators may receive contracts governing payout terms.</li>
                    <li>Payout requests can be made by creators, with minimum payout handled case by case.</li>
                    <li>Chargebacks may lead to legal action if not discussed and resolved in advance.</li>
                    <li>Tax obligations are the responsibility of the person receiving payout.</li>
                </ul>
            </section>

            <section className="panel">
                <h2>5. Suspension and termination</h2>
                <p>
                    We may suspend or terminate access for violations of these Terms, abuse, fraud, or behavior
                    that creates legal, operational, or security risk.
                </p>
            </section>

            <section className="panel">
                <h2>6. Disclaimer and limitation of liability</h2>
                <p>
                    The service is provided on an "as is" and "as available" basis.
                    To the extent permitted by law, we disclaim warranties and limit liability for indirect,
                    incidental, or consequential damages arising from use of the service.
                </p>
            </section>

            <section className="panel">
                <h2>7. Changes to these Terms</h2>
                <p>
                    If these Terms change, users may receive a one-time popup notice during a one-month period after
                    the update. After that period, continued use may be treated as acceptance of the updated Terms.
                </p>
            </section>

            <section className="panel">
                <h2>8. Governing law</h2>
                <p>
                    These Terms are governed by the laws of Germany.
                </p>
            </section>

            <section className="panel">
                <h2>9. Contact</h2>
                <p>
                    Questions about these Terms can be sent to support@pollarity.app.
                </p>
            </section>
        </div>
    );
}

export default TermsOfService;
